import { formatPointsForDisplay } from '@/lib/units/unit-conversion'
import { DEFAULT_GUTTER_POINTS, MIN_GUTTER_POINTS, POINTS_PER_MM } from '../constants/guide-limits'
import type { GuideUnit } from '../types/guide-unit'
import { guideUnitToUnitOfMeasure } from './guide-unit'

export function formatFieldValue(points: number, unit: GuideUnit, decimalPlaces?: number): string {
  const safePoints =
    Number.isFinite(points) && points >= MIN_GUTTER_POINTS ? points : DEFAULT_GUTTER_POINTS
  const targetUnit = guideUnitToUnitOfMeasure(unit)

  if (targetUnit) {
    return formatPointsForDisplay(
      safePoints,
      targetUnit,
      decimalPlaces !== undefined ? { decimalPlaces } : undefined
    )
  }

  return (safePoints / POINTS_PER_MM).toFixed(decimalPlaces ?? 2).replace(/\.?0+$/, '')
}
